import { render, staticRenderFns } from "./ContactProfile.vue?vue&type=template&id=25d00494&"
import script from "./ContactProfile.vue?vue&type=script&lang=js&"
export * from "./ContactProfile.vue?vue&type=script&lang=js&"
import style0 from "./ContactProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContactProfile.vue"
export default component.exports